// @flow

// Return whether or not something is exactly equal to true.
export const isTrue = (x: any) => x === true;

// Checks if any values in an array are exactly true.
export const any = (xs: Array<any>) => xs.some(isTrue)


// WEBPACK FOOTER //
// ./src/helpers/conditionals.js